module.exports = __webpack_public_path__ + "static/lendingblock_logo-3301739d787ff0a8c1991176cbd4a07b.svg";